export default "__VITE_ASSET__5f3e51bc__"